import React from 'react';
import { OneToAllTableExchange } from '../ExchangeRateConverter/OneToAllTableExchange.';
import CurrencyConverter from '../Components/CurrencyConverter';
function FxExchange() {
  return (
    <section className='px-4 sm:px-10 md:px-20 max-w-[1440px] mx-auto mt-8 md:mt-24 font-pin flex flex-col gap-10'>
      <div className='flex flex-col gap-[2rem]'>
        <h2 className='text-2xl font-semibold'>FX Exchange</h2>
      </div>
      <CurrencyConverter />
      <div>
        <h4 className='mb-2 font-semibold text-p-bk text-[18px] font-pin'>
          Currency Exchange Rate
        </h4>
        <OneToAllTableExchange />
      </div>
    </section>
  );
}
export default FxExchange;
